/**
 * Sent with consumer Stripe billing API calls so the server can build Checkout / Portal
 * return URLs on the same origin as the open tab (e.g. http://localhost:8081 vs production).
 * The API validates this against the CORS allowlist.
 */
export function getWebAppOriginForStripeBillingRedirects(): string | undefined {
  if (typeof window === 'undefined' || window.location?.origin == null) {
    return undefined
  }
  return window.location.origin
}
